import { fetchLoyaltyEstimateThunk } from 'actions/loyalty/LoyaltyActions';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getMarketplace } from 'reducers/marketplace/MarketplaceSelectors';
import {
    getOnlineBookingCustomer,
    getOnlineBookingItems
} from 'reducers/onlineBooking/OnlineBookingSelectors';
import { dispatch } from 'store';
import { buildLoyaltyEstimateItems } from 'utils/loyaltyUtils';

const DEBOUNCE_MS = 300;

/**
 * Requests a fresh Loyalty Points estimate whenever the marketplace or the
 * booking's resolved line items change, debounced 300ms. The request is always
 * sent when items exist (no client-side "qualifying" gate); the response drives
 * whether the banner is shown.
 */
export const useLoyaltyEstimate = (): void => {
    const marketplace = useSelector(getMarketplace);
    const bookingItems = useSelector(getOnlineBookingItems);
    const customer = useSelector(getOnlineBookingCustomer);
    const customerId = customer.id;

    const items = useMemo(() => buildLoyaltyEstimateItems(bookingItems), [bookingItems]);

    useEffect(() => {
        if (!marketplace.id || items.length === 0) {
            return;
        }

        const timeout = setTimeout(() => {
            dispatch(fetchLoyaltyEstimateThunk(marketplace.id, items, customerId));
        }, DEBOUNCE_MS);

        return () => clearTimeout(timeout);
    }, [marketplace.id, items, customerId]);
};
